import { Register } from './register';

export class NavigationEvent {
  periodStartDate: string;
  periodEndDate: string;
  regimeId: number;
  register: Register;

  isComplete = () => this.periodEndDate && this.regimeId && this.register;

  constructor(init?: Partial<NavigationEvent>) {
    Object.assign(this, init);
  }
}
